import React from 'react';
import { Button, Card, Label, TextInput } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { routes } from '../../routes';
import { loginYup } from '../../resolvers';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useReducerAsState } from '../../hooks/useReducerAsState';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/authContext';

interface IFormInput {
    email: string;
    password?: string | undefined;
}

interface LoginState {
    loading: boolean;
}

const LoginScreen = () => {
    const { t } = useTranslation();
    const navigator = useNavigate();
    const { singIn } = useAuth();

    const [state, setState] = useReducerAsState<LoginState>({
        loading: false
    });

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(loginYup)
    });

    const _setLoading = (loading: boolean) => setState({ loading });

    const _onSubmit: SubmitHandler<IFormInput> = async (data) => {
        if (!data.email || !data.password) return;
        _setLoading(true);
        const response = await singIn({
            email: data.email,
            password: data.password
        });
        _setLoading(false);

        if (response.length > 0) {
            toast.error(response);
            return;
        }

        navigator(routes.DASHBOARD, { replace: true });
    };

    return (
        <div className="max-w-xl mx-auto min-h-screen flex flex-col justify-center p-12">
            <Card className="flex rounded-lg border border-gray-200 bg-white shadow-md dark:border-gray-700 dark:bg-gray-800 flex-col">
                <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                    {t('hello_welcome_again')}
                </h5>
                <p className="font-normal text-gray-700 dark:text-gray-400">
                    Por favor ingresa tus credenciales para continuar.
                </p>
                <div>
                    <div className="mb-2 block">
                        <Label htmlFor="email1" value="Email" />
                    </div>
                    <TextInput
                        id="email1"
                        type="email"
                        placeholder="name@email.com"
                        required
                        {...register('email')}
                        helperText={errors && errors.email ? errors.email.message : ''}
                        color={errors && errors.email ? 'failure' : 'gray'}
                    />
                </div>
                <div>
                    <div className="mb-2 block">
                        <Label htmlFor="password1" value="Contraseña" />
                    </div>
                    <TextInput
                        id="password1"
                        type="password"
                        required
                        {...register('password')}
                        helperText={errors && errors.password ? errors.password.message : ''}
                        color={errors && errors.password ? 'failure' : 'gray'}
                    />
                </div>
                <Button color="dark" onClick={handleSubmit(_onSubmit)} isProcessing={state.loading}>
                    Iniciar sesión
                </Button>
            </Card>
        </div>
    );
};

export default LoginScreen;
